<template>
   <DashboardFlex msg="Welcome to Dashboard ( Home )"/>
</template>

<script>
// @ is an alias to /src
import DashboardFlex from "@/components/Flex/Dashboard.vue";

export default {
  name: "Home",
  components: {
    DashboardFlex,
  },
  data() {
    return {
      //
    }
  },
  created(){
    //
  }
};
</script>
